/** Customer-facing Clarity company introduction for the proposal Clarity tab. */

export type DtoolsClarityTabSection = {
  eyebrow: string;
  title: string;
  body: string;
};

export const DTOOLS_CLARITY_TAB_SECTIONS: DtoolsClarityTabSection[] = [
  {
    eyebrow: "Who we are",
    title: "Clarity designs private cinema and smart home experiences",
    body:
      "Clarity is a Singapore-based specialist in private cinema, high-performance audio, and integrated smart home systems. We work with homeowners, architects, and designers to translate ambition into systems that are elegant to live with and dependable to own.",
  },
  {
    eyebrow: "Private cinema",
    title: "Cinema-grade performance, tailored to your space",
    body:
      "From projection and immersive audio to control and calibration, we specify equipment that performs as one system — not a collection of parts. Every proposal reflects how you will actually watch, listen, and use the space.",
  },
  {
    eyebrow: "Smart home & integration",
    title: "Seamless control across your home",
    body:
      "Where your project includes automation, networking, or whole-home integration, we design for reliability first — intuitive control, stable connectivity, and equipment that works together day after day.",
  },
  {
    eyebrow: "How we propose",
    title: "A curated system — not a parts list",
    body:
      "Each option in this proposal is a complete, considered package. Components are selected for how they work together, the experience they deliver, and the outcome you can expect — so you can compare options with confidence.",
  },
];

export function buildDtoolsClarityTabIntro(customerIntroduction?: string | null): string | null {
  const intro = String(customerIntroduction ?? "").trim();
  return intro || null;
}
